import OverviewTab from "~/pages/SuperAdminDashboard/OverviewTab";

const SuperAdminDashboard = () => {
  return <OverviewTab />;
};

export default SuperAdminDashboard;
